import { getAssessmentDuration } from "../../../../utils";
import { STATIC_STRINGS } from "@asez/shared";

function Report({ report }) {
  const totalTime = getAssessmentDuration(report.totalAssessmentTime);

  return (
    <div>
      <div className="grid grid-cols-2 gap-4">
        <div className="bg-gray-50 p-4 rounded-lg text-center">
          <p className="text-sm text-gray-500">
            {STATIC_STRINGS.OVERALL_REPORT_ENUM.TOTAL_ASSESSMENT_TIME}
          </p>
          <p className="text-xl font-bold">{totalTime}</p>
        </div>
        <div className="bg-gray-50 p-4 rounded-lg text-center">
          <p className="text-sm text-gray-500">
            {STATIC_STRINGS.OVERALL_REPORT_ENUM.SCORE_PERCENT}
          </p>
          <p className="text-xl font-bold text-orange-500">
            {report.totalMarks}%
          </p>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div className="mt-4 bg-gray-50 p-4 rounded-lg flex justify-between items-start">
          <div className="text-center w-1/2">
            <p className="text-sm text-gray-500">
              {STATIC_STRINGS.OVERALL_REPORT_ENUM.TRUST_SCORE}
            </p>
            <p className="text-xl font-bold text-green-500">
              {(report.trustScore * 100).toFixed(1)}%
            </p>
          </div>
          <div className="w-1/2 text-center">
            <ul className="mt-2 space-y-1">
              {report.proctorResponses?.map((response) => (
                <li key={response.label} className="text-xs font-medium">
                  {response.label}:{" "}
                  {typeof response.value === "boolean"
                    ? response.value
                      ? "Yes"
                      : "No"
                    : response.value}
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4 mt-4 bg-gray-50 p-1 rounded-lg">
          <div>
            <h3 className="text-sm font-semibold">
              {STATIC_STRINGS.OVERALL_REPORT_ENUM.STRONG_POINTS}
            </h3>
            <div className="flex flex-wrap gap-2 mt-2">
              {report.strongAreas?.map((point) => (
                <span key={point} className="text-xs font-medium chip">
                  {point}
                </span>
              ))}
            </div>
          </div>
          <div>
            <h3 className="text-sm font-semibold">
              {STATIC_STRINGS.OVERALL_REPORT_ENUM.AREAS_OF_IMPROVEMENT}
            </h3>
            <div className="flex flex-wrap gap-2 mt-2">
              {report.weakAreas?.map((area) => (
                <span key={area} className="text-xs font-medium chip">
                  {area}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="mt-4 p-4 bg-orange-50 rounded-lg">
        <h3 className="font-bold">
          {STATIC_STRINGS.OVERALL_REPORT_ENUM.OVERALL_FEEDBACK}
        </h3>
        <p className="text-sm mt-2">{report.feedback}</p>
      </div>
    </div>
  );
}

export default Report;
